import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {  faTrash,
          faFileExcel,
          faAngleRight,
          faAngleLeft,
          faUpload,
          faSquarePlus,
          faMagnifyingGlass,
          faPen,
          faPenToSquare,
          faCircleXmark
        } from '@fortawesome/free-solid-svg-icons';
import { ApiService } from '../services/api.service';
import { routes } from '../app.routes';
import { ToastrService } from 'ngx-toastr';
import { count } from 'rxjs';
import { exportToExcel, getFileNameFromResponse } from '../../common/utils';
import saveAs from 'file-saver';
import {DEFAULT_TABLE_PAGE_SIZE_OPTIONS} from '../shared/constants/pagination.constants';

@Component({
    selector: 'app-events',
    imports: [CommonModule, FormsModule, FontAwesomeModule],
    templateUrl: './events.component.html',
    styleUrl: './events.component.css'
})
export class EventsComponent {
    readonly pageSizeOptions = DEFAULT_TABLE_PAGE_SIZE_OPTIONS;

  searchText: string | null = null;
    recordsPerPage: number = 10;
    currentPage: number = 1;
    events:any = []; 
    nextPage: number | null = null;
    previousPage: number | null = null;
    limit: number = 10;
    showConfirmationDialog: boolean = false;
    pId: number = 0;
    totalRecords:number = 0
    showEvent: Boolean = false;
    event: string = '';
  
    constructor(private apiService: ApiService, library: FaIconLibrary, private router: Router,  private toastr:ToastrService) {
      this.getEvents(this.currentPage, this.recordsPerPage);
      library.addIcons(faTrash,
                      faFileExcel,
                      faAngleRight,
                      faAngleLeft,
                      faUpload,
                      faSquarePlus,
                      faMagnifyingGlass,
                      faPen,
                      faPenToSquare,
                      faCircleXmark
                    );
      
    }


  
    getEvents(page: number, pageSize: number){
      this.apiService.getAllEvents(page, pageSize).subscribe({
        next: (data: any) => {
          this.events = data['results'];
          this.totalRecords = data['count'];
          this.nextPage = data['next']
          this.previousPage = data['previous']
        },error: (err) =>{
          this.toastr.error('something went wrong while getting events', 'Error')
        }
      });
    }
   
    get totalPages(): number {
        let totalPage = Math.ceil(this.totalRecords / this.recordsPerPage);
        if (totalPage === 0){
          totalPage = 1;
        }
        return totalPage;
      }
  
    deleteRecord(index: number) {}
    next() {
      if (this.nextPage){
        this.currentPage++;
        this.getEvents(this.currentPage, this.recordsPerPage)
      }
    }
  
    previous() {
      if (this.previousPage){
        this.currentPage--;
        this.getEvents(this.currentPage, this.recordsPerPage)
        }
    }
  
    selectPageSize(){
      if(this.recordsPerPage){
        // debugger;
        this.currentPage = 1;
        this.getEvents(this.currentPage, this.recordsPerPage)
      }
    }
    
    
    searchEvents(){
  
      // console.log('searchText', this.searchText)
      // this.currentPage = 1;
      // this.apiService.getSearchVehicle(this.currentPage, this.recordsPerPage, this.searchText).subscribe(data => {
        
      //   this.events = data['results'];
      //   this.totalRecords = data['count'];
      //   this.nextPage = data['next']
      //   this.previousPage = data['previous']
      // });
    }
  
    exportToExcel() {
    //   this.apiService.exportVehicleDB(this.currentPage, this.recordsPerPage, this.searchText).subscribe({
    //     next: (response: any) => {
    //       const fileName = getFileNameFromResponse(response);
    //       saveAs(response.body, fileName);
         
    //     },
    //     error: (err) => {
    //       console.log(err.error)
    //       this.toastr.error(`${err}`)
    //     }
  
    //   })
    }

    // Modal
  openEvent(event: string) {
    this.event = event;
    this.showEvent = true;
  }

  closeEvent() {
    this.showEvent = false;
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const modalElement = document.querySelector('.modal-content');
    if (modalElement && !modalElement.contains(target)) {
      this.showEvent = false;
    }
  }

}
